import { useEffect, useRef } from "react";

import { agentClient } from "../agentClient";
import { targetKey, type Target, type TargetKey } from "../store/targets";

/** Holds a subscription to the target while the calling view is mounted; returns its key. */
export function useAgentTarget(target: Target): TargetKey {
  const key = targetKey(target);
  const latest = useRef(target);
  latest.current = target;
  useEffect(() => {
    const held = latest.current;
    agentClient.retain(held);
    return () => agentClient.release(held);
  }, [key]);
  return key;
}
